import classNames from 'classnames';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { DataLayerProps } from 'eco-design-micro/props/DataLayerProps';
import gtm from 'eco-design-reliance/gtm';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';
import React, { Fragment, useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import EcoVideoItemsCard, { EcoVideoItemsItemProps } from './EcoVideoItem';
import './index.scss';

export interface EcoVideoItemsProps {
    /**
     * 布局方式
     *
     * swiper 左右拖动
     *
     * spread 铺开
     */
    layout?: 'swiper' | 'spread';
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 列表
     */
    items?: EcoVideoItemsItemProps[];
    /**
     * 样式名
     */
    className?: string;
    /**
     * 视频埋点
     */
    dataLayerVideo?: DataLayerProps;
}

/**
 * 多栏图片(标题 + 描述)
 */
const EcoVideoItems: React.FC<EcoVideoItemsProps> = ({ theme, layout = 'swiper', className, dataLayerVideo, ...reset }) => {
    const props = reset || {};
    const prefixCls = `eco-video-items`;
    const items = props.items || [];
    const [activeItem, setActiveItem] = useState<EcoVideoItemsItemProps>({});

    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-layout-${layout}`]: layout,
        [`${prefixCls}-length-${items.length}`]: items.length,
    });
    const classes2 = classNames(`${prefixCls}-in`, {
        [`${prefixCls}-in-layout-${layout}`]: layout,
        [`${prefixCls}-in-length-${items.length}`]: items.length,
    });
    const dataLayer_video = dataLayerVideo || {
        event: 'uaEvent',
        event_name: 'video',
        position: 'Product Detail_1',
    };
    // 点击切换打开
    const openItemHandle = (item: EcoVideoItemsItemProps, index: number) => {
        setActiveItem(item);
        try {
            gtm.push({
                ...dataLayer_video,
                title_name: item.title,
            });
        } catch (error) {
            /* empty */
        }
    };
    // 点击关闭
    const closeItemHandle = () => {
        setActiveItem({});
    };
    const [spaceBetweenN, setSpaceBetweenN] = useState(24);
    useEffect(() => {
        const initHandle = () => {
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenN(24);
            } else {
                setSpaceBetweenN(16);
            }
        };
        initHandle();
    }, []);
    return (
        <>
            <div className={classes}>
                {layout === 'spread' && (
                    <div className={classes2}>
                        {items.map((item: EcoVideoItemsItemProps, index: number) => {
                            return (
                                <Fragment key={index}>
                                    <EcoVideoItemsCard {...item} index={index} openItemHandle={openItemHandle} />
                                </Fragment>
                            );
                        })}
                    </div>
                )}
                {layout === 'swiper' && (
                    <Swiper
                        className={classes2}
                        slidesPerView={'auto'}
                        spaceBetween={spaceBetweenN}
                        navigation={{
                            nextEl: '.eco-swiper-button-next',
                            prevEl: '.eco-swiper-button-prev',
                        }}
                        modules={[Navigation]}
                    >
                        {items.map((item: EcoVideoItemsItemProps, index: number) => {
                            return (
                                <SwiperSlide key={index}>
                                    <EcoVideoItemsCard {...item} index={index} openItemHandle={openItemHandle} />
                                </SwiperSlide>
                            );
                        })}
                        <div className={`eco-swiper-control eco-swiper-control-${theme}`}>
                            <div className="eco-swiper-navigation">
                                <div className="eco-swiper-button-prev">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                                <div className="eco-swiper-button-next">
                                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                </div>
                            </div>
                        </div>
                    </Swiper>
                )}
            </div>
            {activeItem.videoSrc && <EcoDialogVideo open={!!activeItem.videoSrc} src={activeItem.videoSrc} callback={closeItemHandle} />}
        </>
    );
};

export default EcoVideoItems;
